import React from "react"
import CTAMenuLink from "../../../modules/cta_menu_link_module"

const HeaderMenu = ({data}) => {

  return (
    <>
    {data?.length > 0 && 
      <div className="navigation">
          <ul>
            {data?.map((item, index) => {
              return(
                <li key={item.id} className={item?.menu_items?.label ? "menu_item_"+item?.menu_items?.label.replace(/ /g, '_').toLowerCase() : ""}>
                  <CTAMenuLink item={item.menu_items} />
                </li>
              )
            })}         
          </ul>
      </div>
    }
    </>
  )
}

export default HeaderMenu